import { PAYMENTS_ENABLED } from '@makhe/shared';

const STATS = PAYMENTS_ENABLED
  ? [
      { value: 'R0', label: 'Extra buyer fees' },
      { value: 'Student', label: 'Verified to book' },
      { value: 'Held', label: 'Until you confirm' },
      { value: '10%', label: 'Seller fee' },
    ]
  : [
      { value: 'R0', label: 'Platform fees' },
      { value: 'Student', label: 'Verified to book' },
      { value: 'Direct', label: 'Pay your creator' },
      { value: 'Campus', label: 'Between lectures' },
    ];

export function TrustStrip() {
  return (
    <div className="border-y border-makhe-line bg-makhe-bg">
      <div className="mx-auto grid max-w-6xl grid-cols-2 divide-x divide-y divide-makhe-line md:grid-cols-4 md:divide-y-0">
        {STATS.map((stat) => (
          <div key={stat.label} className="flex flex-col items-center gap-1 px-5 py-6 text-center">
            <span className="font-display text-3xl font-semibold tracking-tight text-makhe-brand">
              {stat.value}
            </span>
            <span className="text-[11px] uppercase tracking-widest text-makhe-muted">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
